module.exports = {
  platform: 'chat',
  name: 'Transfer',
  node: 'chat_transfer',
  bg: '#FFFFFF',
  note: '',
  property: {
    type: 'flow_ui_id',
    flow_ui_id: '',
    flow_ui_name: '',
    queue_id: '',
    queue_name: ''
  }
}
